import { datadogRum } from "@datadog/browser-rum";

const APPLICATION_ID = (import.meta.env.VITE_DATADOG_APPLICATION_ID ?? "").trim();
const CLIENT_TOKEN = (import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? "").trim();
const ENV = (import.meta.env.VITE_DATADOG_ENV ?? import.meta.env.VITE_ENVIRONMENT ?? "").trim();
const API_URL = (import.meta.env.VITE_API_URL ?? "").trim();

let ready = false;

export function initDatadog(): void {
  if (!APPLICATION_ID || !CLIENT_TOKEN) return;

  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "beconfident-community-gate",
    env: ENV || undefined,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    allowedTracingUrls: API_URL ? [API_URL] : [],
    defaultPrivacyLevel: "mask-user-input",
  });
  ready = true;
}

export function captureDatadogAction(name: string, properties: Record<string, unknown>): void {
  if (!ready) return;
  datadogRum.addAction(name, properties);
}

export function captureDatadogError(error: unknown, context?: Record<string, unknown>): void {
  if (!ready) return;
  const err = error instanceof Error ? error : new Error(String(error));
  datadogRum.addError(err, context);
}
